import * as React from 'react';
import { useHistory, useLocation } from 'react-router-dom';

function getNumericParam(search: string, paramName: string) {
  const value = Number(new URLSearchParams(search).get(paramName));
  return value > 0 ? value : undefined;
}

export function useNumericQueryParam(
  paramName: string,
): [number | undefined, (value?: number) => void] {
  const { search } = useLocation();
  const history = useHistory();

  const value = getNumericParam(search, paramName);

  const setValue = React.useCallback(
    (next?: number) => {
      const { search: current } = history.location;
      if (getNumericParam(current, paramName) === (next || undefined)) return;
      const params = new URLSearchParams(current);
      if (next) {
        params.set(paramName, String(next));
      } else {
        params.delete(paramName);
      }
      history.replace({ search: params.toString() });
    },
    [history, paramName],
  );

  return [value, setValue];
}
